module.exports = __webpack_public_path__ + "static/media/mw.f075545e.svg";